import { axiosClient, getCSRFToken } from 'www/utils'
import type {
  ApiDoctorCaseServicesParamsGet,
  ApiDoctorCaseServicesResponseGet,
} from 'www/vue_components/common/DoctorCases/api/apiDoctorCaseServices.types'

export default {
  async get({ caseId }: ApiDoctorCaseServicesParamsGet) {
    return axiosClient.get<ApiDoctorCaseServicesResponseGet>(`/api/doctor/case/services/?case_id=${caseId}`, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    }).then(({ data }) => data)
  },
}
